
export const initErrors = {
    shop_id: "",
    cli_type: "",
    nature:"",
    aib:"",
    products:[
        {
            product_id:"",
            quantity:"",
            priceR:"",
            priceTotal:"",
        }
    ],
}
export const initSale = {
    shop_id: "",
    client_ref: "",
    sale_paygo_id: "",
    cli_type: "",
    cli_typeDisplay:{},
    shop_idDisplay:{},
    natureDisplay:{},
    nature:"",
    comments:"",
    discount:0,
    aib:0,
    total:0,
    sale_credit: false,
    sale_tva: false,
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
            stock_id:"",
            price:"",
            priceR:"",
            priceTotal:"",
        }
    ],
}
export const initQuote = {
    shop_id: "",
    client_ref: "",
    sale_paygo_id: "",
    nature:"quote",
    cli_type: "",
    cli_typeDisplay:{},
    shop_idDisplay:{},
    comments:"",
    discount:0,
    total:0,
    sale_tva: false,
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
            stock_id:"",
            price:"",
            priceR:"",
            priceTotal:"",
        }
    ],
}
export const initResa = {
    shop_id: "",
    cli_type: "",
    cli_typeDisplay:{},
    shop_idDisplay:{},
    comments:"",
    usage_date: new Date(),
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
        }
    ],
}
export const initErrorsResa = {
    shop_id: "",
    cli_type: "",
    comments:"",
    usage_date: "",
    products:[
        {
            product_id:"",
            quantity:"",
        }
    ],
}
export const initResaDemand = {
    shop_id: "",
    // cli_type: "",
    // cli_typeDisplay:{},
    shop_idDisplay:{},
    comments:"",
    usage_date: new Date(),
    products:[
        {
            display:{value:"", label:""},
            product_id:"",
            quantity:"",
            max:"",
        }
    ],
}
export const initErrorsResaDemand = {
    shop_id: "",
    // cli_type: "",
    comments:"",
    usage_date: "",
    products:[
        {
            product_id:"",
            quantity:"",
        }
    ],
}
export const initClient = {
    client_lastname:"",
    client_firstname:"",
    client_address:"",
    client_tel:"",
    client_email:"",
    client_city:"",
    client_country:"",
    client_paygo_id:"",
}